import React from "react";
import { observer, inject } from "mobx-react";
import { Nav, Badge } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { STORE_REJECTIONS, STORE_CUSTOMER_ORDERS, STORE_VIN_QUERIES } from "../../constants";
import { RejectionsStore, CustomerOrdersStore, VinQueriesStore } from "../../stores";




@inject(STORE_REJECTIONS, STORE_CUSTOMER_ORDERS, STORE_VIN_QUERIES)
@observer
export class SalesLayout extends React.Component<any, any> {

    private rejectionsStore = (this.props as any)[STORE_REJECTIONS] as RejectionsStore;
    private customerOrdersStore = (this.props as any)[STORE_CUSTOMER_ORDERS] as CustomerOrdersStore;
    private vinQueriesStore = (this.props as any)[STORE_VIN_QUERIES] as VinQueriesStore;

    render() {

        return <div>
            <Nav variant="tabs" defaultActiveKey="/sales/customerorders">
                <LinkContainer to="/sales/customerorders/1">
                    <Nav.Item>
                        <Nav.Link href="/sales/customerorders/1">Заказы
                            {this.customerOrdersStore.unacceptedOrdersCount > 0 ? [
                                ' ',
                                <Badge key={1} variant="warning" title="Неподтвержденных заказов за неделю" > {this.customerOrdersStore.unacceptedOrdersCount}</Badge>,
                                <span key={2} className="sr-only">неподтвержденных заказов</span>
                            ] : []
                            }
                        </Nav.Link>
                    </Nav.Item>
                </LinkContainer>
                <LinkContainer to="/sales/draftorders/1">
                    <Nav.Item>
                        <Nav.Link href="/sales/draftorders/1">Коммерческие предложения</Nav.Link>
                    </Nav.Item>
                </LinkContainer>
                <LinkContainer to="/sales/rejections/1">
                    <Nav.Item>
                        <Nav.Link href="/sales/rejections/1">Отказы
                            {' '}
                            <Badge variant="info">{this.rejectionsStore.newRejectionsCount}</Badge>
                            <span className="sr-only">новых</span>
                        </Nav.Link>
                    </Nav.Item>
                </LinkContainer>
                <LinkContainer to="/sales/vinqueries/1">
                    <Nav.Item>
                        <Nav.Link href="/sales/vinqueries/1">VIN-запросы
                            {' '}
                            <Badge variant="info">{this.vinQueriesStore.unreadedCount}</Badge>
                            <span className="sr-only">новых</span>
                        </Nav.Link>
                    </Nav.Item>
                </LinkContainer>
            </Nav>

            <div>
                {this.props.children}
            </div>
        </div >;
    }
}